import {
  GET_TRANSFERS_SUCCESS,
  GET_TRANSFERS_FAIL,
  GET_STATUS_TRANSFERS_SUCCESS,
  GET_STATUS_TRANSFERS_FAIL,
  GET_COMPLETED_TRANSFERS_SUCCESS,
  GET_COMPLETED_TRANSFERS_FAIL,
  GET_FILTERED_TRANSFERS_MOSCOW_SUCCESS,
  GET_FILTERED_TRANSFERS_MOSCOW_FAIL,
  ADD_TRANSFER_SUCCESS,
  ADD_TRANSFER_FAIL,
  UPDATE_TRANSFER_SUCCESS,
  UPDATE_TRANSFER_FAIL,
  DELETE_TRANSFER_SUCCESS,
  DELETE_TRANSFER_FAIL,
  GET_TRANSFERS_MOSCOW_SUCCESS,
  GET_TRANSFERS_MOSCOW_FAIL,
  GET_TRANSFERS_MOSCOW_LIST_SUCCESS,
  GET_TRANSFERS_MOSCOW_LIST_FAIL,
  UPDATE_TRANSFER_MOSCOW_DATA_SUCCESS,
  UPDATE_TRANSFER_MOSCOW_DATA_FAIL,
  DELETE_TRANSFER_MOSCOW_SUCCESS,
  DELETE_TRANSFER_MOSCOW_FAIL,
  GET_TRANSFERS_PRIORITY_SUCCESS,
  GET_TRANSFERS_PRIORITY_FAIL,
  ADD_TRANSFER_PRIORITY_SUCCESS,
  ADD_TRANSFER_PRIORITY_FAIL,
  UPDATE_TRANSFER_PRIORITY_SUCCESS,
  UPDATE_TRANSFER_PRIORITY_FAIL,
  DELETE_TRANSFER_PRIORITY_SUCCESS,
  DELETE_TRANSFER_PRIORITY_FAIL,
  GET_TRANSFERS_SHIPPING_SUCCESS,
  GET_TRANSFERS_SHIPPING_FAIL,
  DELETE_TRANSFER_SHIPPING_SUCCESS,
  DELETE_TRANSFER_SHIPPING_FAIL,
  GET_AGENTS_SUCCESS,
  GET_AGENTS_FAIL,
  ADD_AGENT_SUCCESS,
  ADD_AGENT_FAIL,
  UPDATE_AGENT_SUCCESS,
  UPDATE_AGENT_FAIL,
  DELETE_AGENT_SUCCESS,
  DELETE_AGENT_FAIL,
  SHOW_LOADING,
  HIDE_LOADING
} from './actionTypes';

const INIT_STATE = {
  transfers: [],
  filtered_transfers: [],
  completed_transfers: [],
  filtered_transfers_moscow: [],
  transfers_priority: [],
  transfers_moscow: [],
  transfers_moscow_data: [],
  transfers_moscow_nom: [],
  transfers_moscow_inv: [],
  transfers_moscow_ser: [],
  transfers_shipping: [],
  agents: [],
  fees: [],
  boxSizes: [],
  managers: [],
  success: '',
  error: null,
  loading: false
};

const transfers = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TRANSFERS_SUCCESS:
      return {
        ...state,
        transfers: action.payload[0],
        agents: action.payload[1],
        fees: action.payload[2],
        boxSizes: action.payload[3],
        managers: action.payload[4]
      };
    case GET_TRANSFERS_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case GET_STATUS_TRANSFERS_SUCCESS:
      return {
        ...state,
        filtered_transfers: action.payload
      };
    case GET_STATUS_TRANSFERS_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case GET_COMPLETED_TRANSFERS_SUCCESS:
      return {
        ...state,
        completed_transfers: action.payload
      };
    case GET_COMPLETED_TRANSFERS_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case GET_FILTERED_TRANSFERS_MOSCOW_SUCCESS:
      return {
        ...state,
        filtered_transfers_moscow: action.payload
      };
    case GET_FILTERED_TRANSFERS_MOSCOW_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case ADD_TRANSFER_SUCCESS:
      return {
        ...state,
        transfers: [...state.transfers, action.payload[0]],
        agents: action.payload[1],
        success: { data: 'success' }
      };
    case ADD_TRANSFER_FAIL:
      return {
        ...state,
        error: action.payload
      };
    case UPDATE_TRANSFER_SUCCESS:
      if (Array.isArray(action.payload[0])) {
        const orders = action.payload[0].reduce((prv, curr) => {
          prv[curr._id] = curr;
          return prv;
        }, {});
        const baseTransfers = state.filtered_transfers && state.filtered_transfers.length > 0 ? state.filtered_transfers : state.transfers;
        const updatedTransfers = baseTransfers
          .map((service) => {
            const id = service._id.toString();
            return id in orders ? { ...service, ...orders[id] } : service;
          })
          .filter((service) => !(service.completed === true || service.agentPaid === true));
        return {
          ...state,
          transfers: updatedTransfers,
          agents: action.payload[1],
          success: { data: 'success' }
        };
        // return {
        //   ...state,
        //   transfers: state.transfers
        //     .map((service) => {
        //       const id = service._id.toString();
        //       return id in orders ? { ...service, ...orders[id] } : service;
        //     })
        //     .filter(
        //       (service) => !(service.completed === true || service.agentPaid === true)
        //     ),
        //   agents: action.payload[1],
        //   success: { data: 'success' },
        // };
      }
      return {
        ...state,
        transfers: state.transfers.map((service) => (service._id.toString() === action.payload[0]._id.toString() ? { service, ...action.payload } : service)),
        agents: action.payload[1],
        success: { data: 'success' }
      };
    case UPDATE_TRANSFER_FAIL:
      return {
        ...state,
        error: action.payload
      };
    case DELETE_TRANSFER_SUCCESS:
      return {
        ...state,
        transfers: state.transfers.filter((service) => service._id.toString() !== action.payload[0]._id.toString()),
        agents: action.payload[1]
      };
    case DELETE_TRANSFER_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case GET_TRANSFERS_PRIORITY_SUCCESS:
      return {
        ...state,
        transfers_priority: action.payload
      };
    case GET_TRANSFERS_PRIORITY_FAIL:
      return {
        ...state,
        error: action.payload
      };
    case ADD_TRANSFER_PRIORITY_SUCCESS:
      return {
        ...state,
        transfers_priority: [...state.transfers_priority, action.payload],
        success: { data: 'success' }
      };
    case ADD_TRANSFER_PRIORITY_FAIL:
      return {
        ...state,
        error: action.payload
      };
    case UPDATE_TRANSFER_PRIORITY_SUCCESS:
      if (Array.isArray(action.payload)) {
        const orders = action.payload.reduce((prv, curr) => {
          prv[curr._id] = curr;
          return prv;
        }, {});
        return {
          ...state,
          transfers_priority: state.transfers_priority.map((service) => {
            const id = service._id.toString();
            return id in orders ? { service, ...orders[id] } : service;
          }),
          success: { data: 'success' }
        };
      }
      return {
        ...state,
        transfers_priority: state.transfers_priority.map((service) => (service._id.toString() === action.payload[0]._id.toString() ? { service, ...action.payload } : service)),
        success: { data: 'success' }
      };
    case UPDATE_TRANSFER_PRIORITY_FAIL:
      return {
        ...state,
        error: action.payload
      };
    case DELETE_TRANSFER_PRIORITY_SUCCESS:
      return {
        ...state,
        transfers_priority: state.transfers_priority.filter((service) => service._id.toString() !== action.payload._id.toString())
      };
    case DELETE_TRANSFER_PRIORITY_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case GET_TRANSFERS_MOSCOW_SUCCESS:
      return {
        ...state,
        transfers_moscow: action.payload
      };
    case GET_TRANSFERS_MOSCOW_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case GET_TRANSFERS_MOSCOW_LIST_SUCCESS:
      return {
        ...state,
        transfers_moscow_nom: action.payload[0],
        transfers_moscow_inv: action.payload[1],
        transfers_moscow_ser: action.payload[2]
      };
    case GET_TRANSFERS_MOSCOW_LIST_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case DELETE_TRANSFER_MOSCOW_SUCCESS:
      return {
        ...state,
        transfers_moscow: state.transfers_moscow.filter((service) => service._id.toString() !== action.payload._id.toString())
      };
    case DELETE_TRANSFER_MOSCOW_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case GET_TRANSFERS_SHIPPING_SUCCESS:
      return {
        ...state,
        transfers_shipping: action.payload
      };
    case GET_TRANSFERS_SHIPPING_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case UPDATE_TRANSFER_MOSCOW_DATA_SUCCESS:
      if (Array.isArray(action.payload)) {
        const orders = action.payload.reduce((prv, curr) => {
          prv[curr._id] = curr;
          return prv;
        }, {});
        return {
          ...state,
          transfers_moscow_data: state.transfers_moscow_data.map((service) => {
            const id = service._id.toString();
            return id in orders ? { ...service, ...orders[id] } : service;
          }),
          transfers_shipping: state.transfers_shipping.map((service) => {
            const id = service._id.toString();
            return id in orders ? { ...service, ...orders[id] } : service;
          }),
          error: null,
          success: 'success'
        };
      }
      return {
        ...state,
        transfers_shipping: state.transfers_shipping.map((service) => (service._id.toString() === action.payload[0]._id.toString() ? { service, ...action.payload } : service)),
        success: { data: 'success' },
        error: null
      };

    case UPDATE_TRANSFER_MOSCOW_DATA_FAIL:
      return {
        ...state,
        error: action.payload.data.error
      };

    case DELETE_TRANSFER_SHIPPING_SUCCESS:
      return {
        ...state,
        transfers_shipping: state.transfers_shipping.filter((service) => service._id.toString() !== action.payload._id.toString()),
        completed_transfers: state.completed_transfers.filter((service) => service._id.toString() !== action.payload._id.toString())
      };
    case DELETE_TRANSFER_SHIPPING_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case GET_AGENTS_SUCCESS:
      return {
        ...state,
        agents: action.payload[0],
        fees: action.payload[1]
      };
    case GET_AGENTS_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case ADD_AGENT_SUCCESS:
      return {
        ...state,
        agents: [...state.agents, action.payload],
        success: { data: 'success' }
      };
    case ADD_AGENT_FAIL:
      return {
        ...state,
        error: action.payload
      };
    case UPDATE_AGENT_SUCCESS:
      return {
        ...state,
        agents: state.agents.map((service) => (service._id.toString() === action.payload._id.toString() ? { service, ...action.payload } : service)),
        // agents: action.payload,
        success: { data: 'success' }
      };
    case UPDATE_AGENT_FAIL:
      return {
        ...state,
        error: action.payload
      };
    case DELETE_AGENT_SUCCESS:
      return {
        ...state,
        agents: state.agents.filter((service) => service._id.toString() !== action.payload._id.toString())
      };
    case DELETE_AGENT_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case SHOW_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case HIDE_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    default:
      return state;
  }
};

export default transfers;
